module.exports = __webpack_public_path__ + "static/media/contactless.30c05b18.png";